import { render, staticRenderFns } from "./btnTagEdit.vue?vue&type=template&id=2b029c76"
import script from "./btnTagEdit.vue?vue&type=script&lang=js"
export * from "./btnTagEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports